<template>
  <el-dialog :title="formData.id?'编辑':'添加'" :visible.sync="modelShow">
    <el-form ref="modelForm" :model="formData" label-width="120px" >
      <el-form-item label="文件">
        <el-upload
          :action="fileUrl+'/file/upload?dir=imgPool'"
          :show-file-list="false"
          :headers="uploadHeaders"
          list-type="picture-card"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="fileId" style="width: 100%;height: 100%" src="http://qxsdcloud.com/jmreport/desreport_/corelib/jiade.jpg" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
      </el-form-item>
      <el-form-item>
        <el-button @click="modelShow = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {saveOrUpdateApi} from "@/api/ExcelFile";

import {fileUrl} from "/env";
import {getToken} from "@/utils/auth";

export default {
  name: "ExcelFileForm",
  data() {
    return {
      uploadHeaders:{'X-Token':getToken()},
      fileUrl:fileUrl,
      fileId:'',
      formData:{},
      modelShow:false,
      groups:[]
    }
  },
  methods:{
    opened(isEdit,row){
    
      this.formData = {};
      this.fileId = '';
      if (isEdit){
        this.formData = row;
        this.fileId = this.formData.fileId
      }
      this.modelShow = true;
    },
    submitForm(){
      this.$refs['modelForm'].validate((valid) => {
        if (valid) {
          if (!this.fileId){
            this.$message.error('请上传Excel')
          }
          this.formData.fileId = this.fileId
          saveOrUpdateApi(this.formData).then(() => {
            this.modelShow = false
            this.$emit('refreshTable');
          })
        }
      })
    },
    handleAvatarSuccess(res,file) {
      if (res.code !== 1){
        this.$message.error(res.msg)
      }
      this.fileId = res.data;
      this.formData.imgName = file.name.substr(0,file.name.lastIndexOf('.'));
    },
    beforeAvatarUpload(file) {
      const isIMG = file.type === 'application/vnd.ms-excel';
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isIMG) {
        this.$message.error('上传资源只能是excel格式!');
      }

      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isIMG && isLt2M;
    }
  }
}
</script>

<style scoped>

</style>
